import { useContext } from "react";
import VectorModalContext from "../contexts/vector-modal-context/VectorModalContext";

export const useVectorModal = () => {
  const context = useContext(VectorModalContext);
  if (context === undefined) {
    throw new Error('useVectorModal must be used within a VectorModalProvider');
  }
  
  return context;
};